import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './ActionItem.module.css'
import {clsx} from 'clsx'

export function ActionItemSkeleton() {
  return (
    <li className={styles.container}>
      <span className={styles.leadingIcon}>
        <SkeletonBox height="16px" width="16px" />
      </span>
      <div className={clsx(styles.content, styles.skeletonContent)}>
        <SkeletonText size="bodyMedium" className={styles.skeletonTitle} />
        <SkeletonText size="bodySmall" className={styles.skeletonDescription} />
      </div>
    </li>
  )
}
